import http from '@/plugins/axios/axios';

export default class JustificativaService {

    salvar(requisicao) {       
        return http.post('/api/justificativa/salvar', requisicao);
    }

    excluir(requisicao) {       
        return http.post('/api/justificativa/excluir', requisicao);
    }

    buscar(requisicao) {       
        return http.post('/api/justificativa/buscar', requisicao);
    }
    
    listar(requisicao) {       
        return http.post('/api/justificativa/listar', requisicao);
    }    
}